export default function Panel({
  children,
  maxWidth = "lg", // "sm" | "md" | "lg" | "xl" | "2xl" | "full"
  centered = false,
  className = "",
}) {
  const maxWidthClasses = {
    sm: "max-w-sm",
    md: "max-w-md",
    lg: "max-w-lg",
    xl: "max-w-xl",
    "2xl": "max-w-2xl",
    "4xl": "max-w-4xl",
    full: "max-w-full",
  };

  const panelInnerClasses =
    "p-10 rounded-2xl flex flex-col border-2 border-[var(--color-border)] bg-[var(--color-bg-card)] shadow-[0_0_15px_var(--color-shadow-primary)]";

  const panelContent = (
    <div className={`w-full ${maxWidthClasses[maxWidth]}`}>
      <div className={`${panelInnerClasses} ${className}`}>{children}</div>
    </div>
  );

  if (centered) {
    return (
      <div className="flex-1 flex items-center justify-center p-4">
        {panelContent}
      </div>
    );
  }

  return panelContent;
}
